import { ResponseModelInterfaceStatic } from "@/service/models/response-model-interface";
import { staticImplements } from "@/utilities/static-implements";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { DrugRevision } from "./drug-revision";

@staticImplements<ResponseModelInterfaceStatic>()
export class DrugHistory
{
    public constructor(
        public revisions: DrugRevision[],
    )
    {
    }

    public static makeFromXml(elem: XmlElementWrapper): DrugHistory
    {
        const revisions = elem
            .firstChildByTag("revisions")
            .mapForEachChildTag("revision", (revisionElem) => {
                return DrugRevision.makeFromXml(revisionElem)
            });

        return new this(revisions)
    }
}
